<template>
  <div class="web-redirect-placeholder d-none" aria-hidden="true"></div>
</template>

<script>
export default {
  props: {
    to: {
      type: String,
      default: "",
    },
  },
  computed: {
    normalizedTarget() {
      return String(this.to || "").trim();
    },
    isExternalTarget() {
      return /^(https?:)?\/\//i.test(this.normalizedTarget);
    },
    isProtocolTarget() {
      return /^(mailto:|tel:|whatsapp:)/i.test(this.normalizedTarget);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.redirectNow();
    });
  },
  watch: {
    to() {
      this.redirectNow();
    },
  },
  methods: {
    redirectNow() {
      if (!this.normalizedTarget) return;

      if (this.isExternalTarget || this.isProtocolTarget) {
        window.location.href = this.normalizedTarget;
        return;
      }

      const target = this.getLink(this.normalizedTarget);
      if (!target) return;

      if (this.$route && this.$route.fullPath === target) return;
      this.$router.replace(target).catch(() => {});
    },
  },
};
</script>
